import React, { useContext, useState, useEffect } from 'react'

import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import ReturnContext from '@/product/context/return/returnContext'
import {
    dateFormatFunction,
    dateTimeFormatFunction,
    currencyFormat,
    capitalize,
} from '@/custom/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Button } from '@mui/material'
import CartItem from '../Invoice/cartItem'
import { LOGO, SITE_NAME } from '@/utils/UI/index'
import Loaders from '@/product/components/molecules/Loaders'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'

const InvoiceView = (props) => {
    const history = useHistory()
    const returnContext = useContext(ReturnContext)
    const { single_invoice, getSingleInvoice, all_invoices } = returnContext
    let invoiceID = props.match?.params?.id ? props.match.params.id : 0
    let userId = props.match?.params?.uid ? props.match.params.uid : 0
    const [isLoading, setIsLoading] = useState(true)

    const [viewContent, setViewContent] = React.useState(null)
    const [print, setPrint] = useState(false)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const formik = useFormik({
        initialValues: {
            cart_id: 0,
        },
        validateOnBlur: false,
    })

    // temp lang Manager
    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }

    useEffect(() => {
        resetFrom()
    }, [props])

    useEffect(() => {
        if (invoiceID && userId) {
            setIsLoading(true)
            formik.values.invoice_id = invoiceID
            formik.values.user_id = userId
            getSingleInvoice(formik.values)
        } else {
            resetFrom()
        }
    }, [invoiceID])
    let [invoiceDetails, setInvoiceDetails] = useState({
        invoiceProducts: [],
        cartValues: {},
        appointmentDetail: {},
        locationDetail: {},
        invoiceTransactions: [],
        invoiceAddress: [],
        invoiceUser: [],
    })

    useEffect(() => {
        if (single_invoice && single_invoice.invoicerecords.length) {
            setIsLoading(false)
            setInvoiceDetails({
                invoiceProducts: single_invoice.invoicerecords.length
                    ? single_invoice.invoicerecords
                    : [],
                cartValues: single_invoice.cartvalues,
                appointmentDetail: single_invoice.appointmentrecord,
                locationDetail: single_invoice.locationrecord,
                invoiceAddress: single_invoice.invoiceaddressrecord,
                invoiceUser: single_invoice.invoiceuserrecord,
                invoiceTransactions: single_invoice.transactionrecords,
            })
        } else {
            resetFrom()
        }
    }, [single_invoice])

    useEffect(() => {
        setInvoiceDetails({
            invoiceProducts: [],
            cartValues: {},
            appointmentDetail: {},
            locationDetail: {},
            invoiceTransactions: [],
            invoiceAddress: [],
            invoiceUser: [],
        })
        return () => {
            setInvoiceDetails({
                invoiceProducts: [],
                cartValues: {},
                appointmentDetail: {},
                locationDetail: {},
                invoiceTransactions: [],
                invoiceAddress: [],
                invoiceUser: [],
            })
        }
    }, [])
    const resetFrom = () => {
        setViewContent(null)
    }

    const ref = React.createRef()
    const options = {}

    const generatePDF = (toPdf) => {
        setPrint(true)
        toPdf()
    }
    const completedPDF = () => {
        setPrint(false)
    }
    return (
        <Layout
            printable={true}
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            <div className="">
                {' '}
                {isLoading ? (
                    <div className="fspLoader">
                        <Loaders isLoading={isLoading} />
                    </div>
                ) : (
                    <div className="container-lg productInvoice">
                        <h3 className="invoiceTitle">{'Return Invoice'}</h3>
                        <div className="d-flex justify-content-between align-items-center mb-2 noPrint">
                            <Button
                                id="invoice_arrow_back"
                                onClick={() => {
                                    history.goBack()
                                    window.scrollTo(0, 0)
                                }}
                                className="moveBack"
                            >
                                <span className="material-icons">
                                    arrow_back
                                </span>
                                {'Back'}
                            </Button>
                            <Button
                                id="return_print"
                                onClick={() => window.print()}
                            >
                                <span className="material-icons">print</span>
                                {'Print'}
                            </Button>
                        </div>
                        <div
                            className={`invoiceView ${
                                print ? 'invoiceViewPrint' : ''
                            }`}
                            ref={ref}
                            style={{ height: '100%', width: '100%' }}
                        >
                            <div className="card-header d-flex justify-content-between align-items-center p-4">
                                <a
                                    className="pt-2 d-inline-block"
                                    data-abc="true"
                                >
                                    <img
                                        src={LOGO}
                                        className="invLogo"
                                        alt={SITE_NAME}
                                        style={{ width: '160px' }}
                                    />
                                </a>
                                <div className="float-right invDate">
                                    <h5 className="mb-0">
                                        {'Return Invoice'}: #
                                        {
                                            invoiceDetails.cartValues
                                                .return_invoice
                                        }{' '}
                                    </h5>
                                    <h5 className="mb-0">
                                        {'Return Date'}:{' '}
                                        {dateTimeFormatFunction(
                                            invoiceDetails.cartValues
                                                .cart_returndate
                                        )}
                                    </h5>
                                    <h5 className="mb-0">
                                        {'Invoice Status'}:{' '}
                                        {invoiceDetails.cartValues.cart_returned
                                            ? 'Returned'
                                            : 'Pending'}
                                    </h5>
                                    {invoiceDetails.cartValues.reason ? (
                                        <h5 className="mb-0">
                                            {'Reason'}:{' '}
                                            {capitalize(
                                                invoiceDetails.cartValues.reason
                                            )}
                                        </h5>
                                    ) : null}
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row mb-4">
                                    {invoiceDetails.invoiceProducts?.length && (
                                        <div className="col-sm-6 invAddr">
                                            <h5 className="mb-3">{'From'}:</h5>
                                            <h3 className="text-dark mb-1">
                                                {SITE_NAME}
                                            </h3>
                                            {/* <div>{'1698 Perimeter Road'}</div>
                                            <div>
                                                {'Greenville'} {'SC'} {'29605'}
                                            </div>
                                            <div> 1 (864) 300-BIDS</div> */}
                                        </div>
                                    )}
                                    {console.log(
                                        invoiceDetails.invoiceUser,
                                        'invoiceD'
                                    )}
                                    {invoiceDetails.invoiceUser?.length ? (
                                        <div className="col-sm-6 invAddr text-right">
                                            <h5 className="mb-3">To:</h5>
                                            <h3 className="text-dark mb-1">
                                                {
                                                    invoiceDetails
                                                        .invoiceUser[0]
                                                        .first_name
                                                }{' '}
                                                {
                                                    invoiceDetails
                                                        .invoiceUser[0]
                                                        .last_name
                                                }
                                            </h3>
                                            {invoiceDetails.invoiceAddress
                                                .length ? (
                                                <>
                                                    <div>
                                                        {
                                                            invoiceDetails
                                                                ?.invoiceAddress[0]
                                                                ?.address1
                                                        }
                                                    </div>
                                                    <div>
                                                        {
                                                            invoiceDetails
                                                                ?.invoiceAddress[0]
                                                                ?.address2
                                                        }
                                                    </div>
                                                    {invoiceDetails
                                                        .invoiceAddress[0]
                                                        .city &&
                                                        invoiceDetails
                                                            .invoiceAddress[0]
                                                            .state && (
                                                            <div>
                                                                {
                                                                    invoiceDetails
                                                                        .invoiceAddress[0]
                                                                        .city
                                                                }
                                                                ,{' '}
                                                                {
                                                                    invoiceDetails
                                                                        .invoiceAddress[0]
                                                                        .state
                                                                }{' '}
                                                                {
                                                                    invoiceDetails
                                                                        .invoiceAddress[0]
                                                                        .country
                                                                }{' '}
                                                                -{' '}
                                                                {
                                                                    invoiceDetails
                                                                        .invoiceAddress[0]
                                                                        .zipcode
                                                                }
                                                            </div>
                                                        )}
                                                </>
                                            ) : null}

                                            <div>
                                                Email:{' '}
                                                {
                                                    invoiceDetails
                                                        .invoiceUser[0].email
                                                }
                                            </div>

                                            <div>
                                                Phone:{' '}
                                                {
                                                    invoiceDetails
                                                        .invoiceUser[0].phone
                                                }
                                            </div>
                                        </div>
                                    ) : null}
                                    {/*<div className="col-sm-6 invAddr text-right">
                                <h5 className="mb-3">To:</h5>
                                {single_invoice && single_invoice.invoicerecords.length ? (
                                    <>
                                        <h3 className="text-dark mb-1">
                                            {all_invoices?.records
                                                .filter(
                                                    (data) =>
                                                        data.custom_users_user_id ==
                                                        single_invoice.invoicerecords[0].user_id,
                                                )
                                                .slice(0, 1)
                                                .map((d) =>
                                                    d.users_user_type === 0
                                                        ? `${d.users_first_name} ${d.users_last_name}`
                                                        : d.users_companyname,
                                                )}
                                        </h3>
                                        {invoiceDetails &&
                                            invoiceDetails.invoiceAddress &&
                                            invoiceDetails.invoiceAddress.length != 0 && (
                                                <>
                                                    {console.log(
                                                        invoiceDetails.invoiceAddress[0],
                                                        'invc',
                                                    )}

                                                    <div>
                                                        {invoiceDetails.invoiceAddress[0].address1}
                                                        <div>
                                                            {invoiceDetails.invoiceAddress[0].city},{' '}
                                                            {invoiceDetails.invoiceAddress[0].state}{' '}
                                                            {invoiceDetails.invoiceAddress[0].zip},
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                    </>
                                ) : null}
                                                    </div>*/}
                                </div>
                                {/* {invoiceDetails.cartValues.cart_payment ? (
                        <>
                            <h4 className="invoiceSubTitle">
                                Payment Type:{' '}
                                {invoiceDetails.cartValues.cart_payment === 'online' ? (
                                    <>{t('online_payment')}</>
                                ) : invoiceDetails.cartValues.cart_payment === 'offline' ? (
                                    <>{t('offline_payment')}</>
                                ) : invoiceDetails.cartValues.cart_payment === 'deposit' ? (
                                    <>{t('deposit')}</>
                                ) : null}
                            </h4>
                        </>
                    ) : null} */}

                                {invoiceDetails.cartValues.internal_reason ? (
                                    <h4 className="invoiceSubTitle">
                                        {'Internal Reason'}:{' '}
                                        {
                                            invoiceDetails.cartValues
                                                .internal_reason
                                        }
                                    </h4>
                                ) : null}
                                {/* {invoiceDetails.appointmentDetail &&
                        invoiceDetails.appointmentDetail.appointmentTime !=
                            '0000-00-00 00:00:00' ? (
                            <>
                                <h4 className="invoiceSubTitle">
                                    {'Appointment Scheduled At'}:{' '}
                                    {dateTimeFormatFunction(
                                        invoiceDetails.appointmentDetail.appointmentTime,
                                    )}
                                </h4>
                            </>
                        ) : null} */}
                                {/*invoiceDetails.appointmentDetail ? (
                            <>
                                <h4 className="invoiceSubTitle">
                                    {t('appointment_scheduled_at')}:{' '}
                                    {dateTimeFormatFunction(
                                        invoiceDetails.appointmentDetail.appointmentTime,
                                    )}
                                </h4>
                            </>
                                    ) : null*/}
                                {invoiceDetails.invoiceTransactions.length ? (
                                    <>
                                        <h4 className="invoiceSubTitle">
                                            {'Refund Details'}
                                        </h4>
                                        <div className="transDet d-flex justify-content-between flex-wrap">
                                            <>
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            {/* <th scope="col">S.No</th> */}
                                                            <th scope="col">
                                                                {'Refund ID'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Refund on'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Method'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Amount'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Status'}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {invoiceDetails.invoiceTransactions.map(
                                                            (data, index) => (
                                                                <tr key={index}>
                                                                    <td
                                                                        data-title={
                                                                            'Refund ID'
                                                                        }
                                                                    >
                                                                        {data.trans_id
                                                                            ? `# ${data.trans_id}`
                                                                            : '-'}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Refund On'
                                                                        }
                                                                    >
                                                                        {dateTimeFormatFunction(
                                                                            data.created_at
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Card'
                                                                        }
                                                                    >
                                                                        {capitalize(
                                                                            data.refund_method
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Amount'
                                                                        }
                                                                    >
                                                                        {currencyFormat(
                                                                            data.amount
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Payment Status'
                                                                        }
                                                                        style={{
                                                                            color:
                                                                                data.status ===
                                                                                'success'
                                                                                    ? 'green'
                                                                                    : 'red',
                                                                        }}
                                                                    >
                                                                        {capitalize(
                                                                            data.status
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </>
                                        </div>
                                    </>
                                ) : null}
                                <h4 className="invoiceSubTitle mt-5">
                                    {'Product Details'}
                                </h4>

                                <div className="table-responsive">
                                    {invoiceDetails.invoiceProducts.length ? (
                                        <div className="cartProducts">
                                            <div>
                                                {invoiceDetails.invoiceProducts.map(
                                                    (data, index) => (
                                                        <CartItem
                                                            data={data}
                                                            from="invoice"
                                                        />
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="row mt-5">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className="table table-clear nellisInvTot">
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            className="left"
                                                            align="right"
                                                        >
                                                            <span className="text-dark">
                                                                {'Items'}
                                                            </span>
                                                        </td>
                                                        <td className="right">
                                                            <span className="text-dark">
                                                                {
                                                                    invoiceDetails
                                                                        .invoiceProducts
                                                                        .length
                                                                }
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    {invoiceDetails.cartValues
                                                        .per_total ? (
                                                        <tr>
                                                            <td
                                                                className="left"
                                                                align="right"
                                                            >
                                                                <span className="text-dark">
                                                                    Bid Amount
                                                                </span>
                                                            </td>
                                                            <td className="right">
                                                                <span className="text-dark">
                                                                    {
                                                                        invoiceDetails
                                                                            .cartValues
                                                                            .per_total
                                                                    }
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                    {invoiceDetails.cartValues
                                                        .total_tax ? (
                                                        <tr>
                                                            <td
                                                                className="left"
                                                                align="right"
                                                            >
                                                                <span className="text-dark">
                                                                    {
                                                                        'Sales Tax'
                                                                    }
                                                                </span>
                                                            </td>
                                                            <td className="right">
                                                                <span className="text-dark">
                                                                    {currencyFormat(
                                                                        invoiceDetails
                                                                            .cartValues
                                                                            .total_tax
                                                                    )}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                    {invoiceDetails.cartValues
                                                        .total_shipping ? (
                                                        <tr>
                                                            <td
                                                                className="left"
                                                                align="right"
                                                            >
                                                                <span className="text-dark">
                                                                    Shipping
                                                                    Amount
                                                                </span>
                                                            </td>
                                                            <td className="right">
                                                                <span className="text-dark">
                                                                    {currencyFormat(
                                                                        invoiceDetails
                                                                            .cartValues
                                                                            .total_shipping
                                                                    )}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                    <tr>
                                                        <td
                                                            className="left"
                                                            align="right"
                                                        >
                                                            <span className="text-dark">
                                                                {'Total Amount'}
                                                            </span>
                                                        </td>
                                                        <td className="right">
                                                            <span className="text-dark">
                                                                {invoiceDetails
                                                                    .invoiceTransactions
                                                                    .length
                                                                    ? currencyFormat(
                                                                          invoiceDetails
                                                                              .invoiceTransactions[0]
                                                                              .amount
                                                                      )
                                                                    : null}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    {invoiceDetails.cartValues
                                                        .total_deposit ? (
                                                        <tr>
                                                            <td
                                                                className="left"
                                                                align="right"
                                                            >
                                                                <span className="text-dark">
                                                                    {
                                                                        'Bid Deposit'
                                                                    }
                                                                </span>
                                                            </td>
                                                            <td className="right">
                                                                <span className="text-dark">
                                                                    -{' '}
                                                                    {currencyFormat(
                                                                        invoiceDetails
                                                                            .cartValues
                                                                            .total_deposit
                                                                    )}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ) : null}

                                                    {invoiceDetails.cartValues
                                                        .total_paid ? (
                                                        <tr>
                                                            <td
                                                                className="left"
                                                                align="right"
                                                            >
                                                                <span className="text-dark">
                                                                    {
                                                                        'Total Refund'
                                                                    }
                                                                </span>
                                                            </td>
                                                            <td className="right">
                                                                <span className="text-dark">
                                                                    {currencyFormat(
                                                                        invoiceDetails
                                                                            .cartValues
                                                                            .total_paid
                                                                    )}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ) : null}

                                                    {/*invoiceDetails.cartValues.total_due_amount ? (
                                                <tr>
                                                    <td className="left" align="right">
                                                        <span className="text-dark">
                                                            {'Pending Amount'}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {currencyFormat(
                                                                invoiceDetails.cartValues
                                                                    .total_due_amount,
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                                            ) : null*/}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4 className="thankText">
                            {'Thank you for shopping with us'}
                        </h4>
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default InvoiceView
